var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2053 21.6602V19.6602C17.2053 18.5993 16.7839 17.5819 16.0337 16.8317C15.2836 16.0816 14.2662 15.6602 13.2053 15.6602H5.20532C4.14446 15.6602 3.12704 16.0816 2.3769 16.8317C1.62675 17.5819 1.20532 18.5993 1.20532 19.6602V21.6602",
    stroke: "#353B60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20532 11.6602C11.4145 11.6602 13.2053 9.8693 13.2053 7.66016C13.2053 5.45102 11.4145 3.66016 9.20532 3.66016C6.99618 3.66016 5.20532 5.45102 5.20532 7.66016C5.20532 9.8693 6.99618 11.6602 9.20532 11.6602Z",
    stroke: "#353B60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2053 21.6602V19.6602C23.2047 18.7739 22.9097 17.9129 22.3667 17.2125C21.8237 16.512 21.0635 16.0117 20.2053 15.7902",
    stroke: "#353B60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2053 3.79016C17.0657 4.01046 17.8284 4.51086 18.373 5.21247C18.9176 5.91408 19.2132 6.77699 19.2132 7.66516C19.2132 8.55333 18.9176 9.41624 18.373 10.1179C17.8284 10.8195 17.0657 11.3199 16.2053 11.5402",
    stroke: "#353B60",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.205322 0.660156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.50127b8d.svg";
export { ForwardRef as ReactComponent };